// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"129":"registration","239":"poll","400":"yes-no","683":"rising-star","996":"info"}[chunkId] + ".style." + {"129":"96c0b6f527dd47ed905d","239":"b752bd2a8f116db167ef","400":"d26d9500268358bfa73a","683":"51994dafbb42834df3f6","996":"87650d12920a24bb6896"}[chunkId] + ".css";
};